import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) return <div className="p-8 text-center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  if (roles && !roles.includes(user.role)) {
    const home =
      user.role === "admin"
        ? "/admin"
        : user.role === "manager"
        ? "/ceed"
        : "/dashboard";
    return <Navigate to={home} replace />;
  }

  return children;
}
